<template>
	<div class="forum-page">
		<div class="forum-page-inner">
			<header class="forum-page-header">
				<div class="forum-page-header-icon">
					<i class="fas fa-comments"></i>
				</div>
				<div>
					<h1 class="forum-page-title">{{ pageTitle }}</h1>
					<p class="forum-page-subtitle" v-html="pageSubtitle"></p>
				</div>
			</header>

			<DiscussionBoardView
				v-if="resolvedScope"
				:key="`${resolvedScope}:${resolvedEntityId || 'global'}`"
				:scope="resolvedScope"
				:entity-id="resolvedEntityId"
			/>
		</div>
	</div>
</template>

<script>
import DiscussionBoardView from "../components/Forum/DiscussionBoardView.vue";
import { BoardScope } from "../constants/forum";

export default {
	name: "Forum",
	components: { DiscussionBoardView },
	computed: {
		resolvedScope() {
			const raw = (this.$route.params.scope || "").toLowerCase();
			if (raw === BoardScope.ProductVariant) return BoardScope.ProductVariant;
			return BoardScope.Global;
		},
		resolvedEntityId() {
			if (this.resolvedScope !== BoardScope.ProductVariant) return null;
			const parsed = parseInt(this.$route.params.entityId, 10);
			return Number.isFinite(parsed) ? parsed : null;
		},
		pageTitle() {
			return this.resolvedScope === BoardScope.ProductVariant ? "Course Forum" : "Forum";
		},
		pageSubtitle() {
			if (this.resolvedScope === BoardScope.ProductVariant) {
				return "Discuss this course with classmates and trainers. Posts here are scoped to the course.";
			}
			return "The global board — open to everyone. For a course-specific board, open a course and use its <strong>Forum</strong> tab.";
		},
	},
};
</script>

<style scoped>
.forum-page {
	min-height: calc(100vh - var(--header-height));
	background-color: #f5f5f5;
	padding-bottom: 32px;
	font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
}

.forum-page-inner {
	margin: 0 auto;
	padding: 16px 24px 0;
	max-width: 960px;
}

.forum-page-header {
	display: flex;
	gap: 14px;
	padding: 4px 0 12px;
	align-items: center;
}

.forum-page-header-icon {
	width: 44px;
	height: 44px;
	border-radius: 50%;
	background-color: #ffffff;
	border: 1px solid #ececec;
	color: var(--secondary-color, #03324d);
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	flex-shrink: 0;
}

.forum-page-title {
	font-size: 20px;
	font-weight: 600;
	color: #0f0f0f;
	margin: 0 0 2px 0;
	letter-spacing: -0.01em;
}

.forum-page-subtitle {
	color: #606060;
	font-size: 13px;
	margin: 0;
	line-height: 1.45;
}

.forum-page-subtitle strong {
	color: #0f0f0f;
	font-weight: 500;
}

@media (max-width: 600px) {
	.forum-page-inner { padding: 10px 12px 0; }
	.forum-page-header { padding: 2px 0 8px; gap: 10px; }
	.forum-page-header-icon { width: 36px; height: 36px; font-size: 15px; }
	.forum-page-title { font-size: 17px; }
	.forum-page-subtitle { font-size: 12.5px; }
}
</style>
